<!-- eslint-disable @angular-eslint/template/no-call-expression -->
@if (shouldDisplayGuidedTour$ | async) {
  <div class="tile">
    <div class="d-flex justify-content-center zero-text p-huge-med">{{ 'guided-tour.headline' | transloco }}</div>
    <div class="d-flex justify-content-center zero-text p-small-reg mt-2 mb-5">{{ 'guided-tour.text' | transloco }}</div>
    @if (showInstrumentOverviewLinks$ | async) {
      <div class="d-flex gap mb-3">
        <div class="circle zero-surface primary-400">
          <web-design-system-icon name="magnifier" color="white" />
        </div>
        <div>
          <div class="zero-text p-base-med">{{ 'guided-tour.steps.investment-product.headline' | transloco }}</div>
          <div class="zero-text p-small-reg">
            {{ 'guided-tour.steps.investment-product.text-start' | transloco }}
            <a class="zero-text link" [routerLink]="ETFS_URL">{{ 'guided-tour.steps.investment-product.link-etfs' | transloco }}</a>
            {{ 'guided-tour.steps.investment-product.text-mid' | transloco }}
            <a class="zero-text link" [routerLink]="STOCKS_URL">{{ 'guided-tour.steps.investment-product.link-stocks' | transloco }}</a>
            {{ 'guided-tour.steps.investment-product.text-end' | transloco }}
          </div>
        </div>
      </div>
    }
    <div class="d-flex gap mb-3">
      <div class="circle zero-surface primary-400">
        <web-design-system-icon name="debit" color="white" />
      </div>
      <div>
        <div class="zero-text p-base-med">{{ 'guided-tour.steps.money.headline' | transloco }}</div>
        <div class="zero-text p-small-reg">
          {{ 'guided-tour.steps.money.text-start' | transloco
          }}<a class="zero-text link" [routerLink]="deposit">{{ 'guided-tour.steps.money.link' | transloco }}</a
          >{{ 'guided-tour.steps.money.text-end' | transloco }}
        </div>
      </div>
    </div>
    @if (investmentStrategyStore.notedStrategy()) {
      <div class="d-flex gap mb-3">
        @if (!investmentStrategyStore.strategyAcknowledged()) {
          <div class="circle zero-surface primary-400">
            <web-design-system-icon name="chess" color="white" />
          </div>
          <div>
            <div class="zero-text p-base-med">
              {{ 'guided-tour.steps.investment-strategy.headline' | transloco }}
            </div>
            <div class="zero-text p-small-reg">
              <a class="zero-text link" (click)="openFirstActionStrategyModal()">{{
                'guided-tour.steps.investment-strategy.link' | transloco
              }}</a
              >{{ 'guided-tour.steps.investment-strategy.text' | transloco }}
            </div>
          </div>
        } @else {
          <div class="circle zero-surface secondary-400">
            <web-design-system-icon name="check" color="white" />
          </div>
          <div>
            <div class="zero-text p-base-med">{{ 'guided-tour.steps.investment-strategy.acknowledged.headline' | transloco }}</div>
            <div class="zero-text p-small-reg">
              {{ 'guided-tour.steps.investment-strategy.acknowledged.text' | transloco }}
            </div>
          </div>
        }
      </div>
    }
    @if (depotFacade.savingsPlanTeaserProductsIgnoreInterest$ | async; as products) {
      @if (products?.length) {
        <div class="d-flex gap mb-3">
          <div class="circle zero-surface primary-400">
            <web-design-system-icon name="pig" color="white" />
          </div>
          <div>
            <div class="zero-text p-base-med">{{ 'guided-tour.steps.savings-plan.headline' | transloco }}</div>
            <div class="zero-text p-small-reg">{{ 'guided-tour.steps.savings-plan.text' | transloco }}</div>
            <div class="d-flex align-items-center gap mt-2">
              @for (product of products; track product.isin) {
                <web-design-system-button size="small" type="secondary" [fullwidth]="true" [routerLink]="[savingsPlanForm, product.isin]">
                  {{ product.name }}
                </web-design-system-button>
              }
              <a class="zero-text link" [routerLink]="savingsPlanHome">{{ 'first-savings-plan-teaser.own' | transloco }}</a>
            </div>
          </div>
        </div>
      }
    }
    <div class="d-flex gap mb-3">
      <div class="circle zero-surface primary-400">
        <web-design-system-icon name="add" color="white" />
      </div>
      <div>
        <div class="zero-text p-base-med">{{ 'guided-tour.steps.trade.headline' | transloco }}</div>
        <div class="zero-text p-small-reg">
          {{ 'guided-tour.steps.trade.text-start' | transloco
          }}<a class="zero-text link" [routerLink]="orderForm">{{ 'guided-tour.steps.trade.link' | transloco }}</a
          >{{ 'guided-tour.steps.trade.text-end' | transloco }}
        </div>
      </div>
    </div>
  </div>
}
